import axios from 'axios'
import Qs from 'qs'

export const myAxios = (option) => {
  const options = {
    method: 'post',
    transformRequest: [
      function (data) {
        data = Qs.stringify(data)
        return data
      },
    ],
    dataType: "json",
    credentials: 'include',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
    },
    ...option,
  }
  return axios(options)
}

/**
 * 批量请求接口
 * @param funcs 请求方法
 * @returns {*}
 */
export const axiosAll = (funcs) => {
  return axios.all(funcs)
  .then(function (data) {
    return data
  });
}
